export default __webpack_public_path__ + "static/2370-b9bb57a4fc03195b6773a2c7f663fc7b.gif";